import { render, staticRenderFns } from "./GetAdvice.vue?vue&type=template&id=eed1e5c8&"
import script from "./GetAdvice.vue?vue&type=script&lang=js&"
export * from "./GetAdvice.vue?vue&type=script&lang=js&"
import style0 from "./GetAdvice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports